import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const NigerFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15639'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15639)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#F0642F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#2DCC45'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0005 8.86663C11.0524 8.86663 11.9052 8.0309 11.9052 6.99997C11.9052 5.96904 11.0524 5.1333 10.0005 5.1333C8.94849 5.1333 8.0957 5.96904 8.0957 6.99997C8.0957 8.0309 8.94849 8.86663 10.0005 8.86663Z'
					fill='#E85C27'
				/>
			</g>
		</svg>
	);
};

export default NigerFlagIcon;
